import { render, staticRenderFns } from "./ShRealnameEproposal.vue?vue&type=template&id=190f610e&"
import script from "./ShRealnameEproposal.vue?vue&type=script&lang=js&"
export * from "./ShRealnameEproposal.vue?vue&type=script&lang=js&"
import style0 from "./ShRealnameEproposal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports